// Rampver "Update KYC" design tokens, mirrored from the design handoff
// (design-baseline/.../colors_and_type.css). Scoped to this wizard so the
// global MUI theme (gold primary, Gill Sans) is left untouched.
import { createTheme } from "@material-ui/core/styles";

export const rv = {
  // Brand greens
  green: "#256141",
  green700: "#1A4A30",
  green900: "#134735",
  green500: "#47956B",
  green300: "#C3ECD5",
  // Gold accents
  gold: "#C8932A",
  goldHover: "#A87819",
  goldLight: "#F4DEAE",
  // Surfaces
  contentBg: "#F6F8F7",
  card: "#FFFFFF",
  mint: "#F1F8F4",
  mint2: "#EAF3EE",
  warm: "#F9F5F2",
  lockedFill: "#F3F4F6",
  // Hairlines
  hairline: "#E5E2DC",
  hairline2: "#ECEAE4",
  hairline3: "#F0EEE8",
  divider: "#E4E4E4",
  // Text
  heading: "#171D25",
  body: "#1A2027",
  muted: "#737373",
  muted2: "#8A8A8A",
  muted3: "#9A9A9A",
  disabled: "#C4C4C4",
  onDark: "#FFFFFF",
  // Inputs
  inputStroke: "#CFCFCF",
  focusStroke: "#256141",
  // Status — pending (amber)
  pendingFg: "#A87819",
  pendingBg: "#FBF3E2",
  pendingBorder: "#EAD9AE",
  // Status — in review (blue)
  reviewFg: "#2A6FA8",
  reviewBg: "#E8F1F8",
  reviewBorder: "#C2DBEE",
  // Status — verified (green)
  verifiedFg: "#1A7A4E",
  verifiedBg: "#E6F4EC",
  verifiedBorder: "#BFE6CE",
  // Info banner
  infoTitle: "#1A4A30",
  infoSub: "#4A6A57",
  infoBg: "#EAF3EE",
  infoBorder: "#D6EADD",
  // Error
  errorFg: "#ED5555",
  errorBg: "#FDEBEB",
  errorBg2: "#FDF6F6",
  // Misc
  sidebarGradient: "linear-gradient(165deg, #134735 0%, #256141 100%)",
  shadowCard: "0 8px 30px rgba(0,0,0,.05)",
  shadowPanel: "0 16px 44px rgba(19,71,53,.3)",
  radiusCard: 14,
  radiusCardLg: 20,
  radiusInput: 10,
  radiusPill: 20,
  fontSans:
    '"Poppins", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
} as const;

// Scoped theme: green focus/primary + gold secondary + Poppins, applied only
// to the wizard content subtree via <ThemeProvider>.
export const kycTheme = createTheme({
  palette: {
    primary: { main: rv.green, dark: rv.green700, contrastText: "#fff" },
    secondary: { main: rv.gold, dark: rv.goldHover, contrastText: "#fff" },
    background: { default: rv.contentBg },
    error: { main: rv.errorFg },
  },
  typography: { fontFamily: rv.fontSans },
  props: {
    MuiTextField: { variant: "outlined", size: "small" },
    MuiFormControl: { variant: "outlined", size: "small" },
  },
});
